import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/w3.css';
import './styles/normalize.css';
import './styles/style.css';

import App from './App.jsx'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
